import React from 'react';

function Header() {
  return (
    <header className="tc-inner-header-style1">
      <div className="container">
        <div className="info col-lg-8">
          <h2 className="js-title fsz-100"> About Us </h2>

        </div>
      </div>
    </header>
  );
}

export default Header;
